import { render, staticRenderFns } from "./EmailCheck.vue?vue&type=template&id=05c1ef2a&scoped=true&"
import script from "./EmailCheck.vue?vue&type=script&lang=js&"
export * from "./EmailCheck.vue?vue&type=script&lang=js&"
import style0 from "./EmailCheck.vue?vue&type=style&index=0&id=05c1ef2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1ef2a",
  null
  
)

export default component.exports